import { connect } from 'react-redux'
import { compose } from 'recompose'

import { makesQueries } from 'data/graphql'
import { fetchAllBookmarkedNotes } from 'remote/notes'
import { bookmarkedNotesFetched } from 'data/notes/actions'
import { selectors as NotesSelectors } from 'data/notes'

const fetchesAllBookmarkedNotes = () =>
  compose(
    connect(
      state => ({
        notes: NotesSelectors.getAllBookmarkedNotes(state),
      }),
      {
        bookmarkedNotesFetched,
      }
    ),
    makesQueries({
      query: fetchAllBookmarkedNotes,
      resyncPolicy: 'refetch',
      getOnResultFromProps: ({ bookmarkedNotesFetched }) => ({
        result,
        meta,
      }) => {
        bookmarkedNotesFetched(result.data.showAllBookmarkedNotes, meta)
      },
    })
  )

export default fetchesAllBookmarkedNotes
